module.exports = __webpack_public_path__ + "a2a21809fce58fba7e9dd3f50bacc0e0.svg";